import Client from '@gate31/uikit/common/components/client/client';
import { VarProduct } from '@gate31/types';
import EventBus from 'EventBus';
import $ from 'jquery';
import { faro } from '@gate31/faro/src';
import { ClientResponseInt } from '@gate31/types/client';
import { Base } from '@gate31/core/src/libs/BaseComponent';
import { Gate31ApiV2, HistoryResponseInt } from '@gate31/core/src/api/gate31-api';
import { CustomCn } from '@gate31/core/src/libs/classname';
import LiquidRender from '@gate31/uikit/common/scripts/liquid-render';
import { ACTION_PROP_ID, CLIENT_GROUP_LIST, FILED_HANDLE_MAP, FILED_MAP, STATUS_DISCOUNT } from './constant';
import { CartLoyaltyBonuses } from './LoyaltyBonuses';
import { LoyaltyCupon } from './LoyaltyCupon';

/*
Условия отображения
1. Если килент в группе СОТРУДНИКИ - скрываем программу лояльности
2. Есди клиент в группе HOME31 - акция только для товаров с меткой SALE. Если таких товаров нет - скрываем программу лояльности.
*/

// TODO Нужно возращать в названии скидки купон чтобы читать его в html и подставлять в форму

interface bodyForCalculateAccrualInt {
    client?: ClientResponseInt['client'];
    // eslint-disable-next-line
    fields_values: { value: string, field_id: number; handle: string }[];
    // eslint-disable-next-line
    order_lines: Array<VarProduct>;
}

// На странице корзины запускается только если клиент авторизован
export class Loyalty extends Base<HTMLElement> {
    cn: CustomCn;

    bonuses: CartLoyaltyBonuses;
    cupon: LoyaltyCupon

    form: HTMLFormElement;
    cuponField: HTMLInputElement;
    bonusesField: HTMLInputElement;

    state: {
        status: 'default' | 'discount' | 'remove-discount';
        bonuses: { applied: number; collected: number; maxToApply: number};
        loyaltyValue: string;
        cupone: {
            value: string;
            error?: string;
        };
    }

    wrapper: HTMLElement | null;
    user: ClientResponseInt | undefined;
    orderList: VarProduct[] | [];

    constructor(options: {
        node: HTMLElement;
        cn: CustomCn;

        bonuses: CartLoyaltyBonuses;
        cupon: any;

    }) {
        super(options.node);

        this.bonuses = options.bonuses;
        this.cupon = options.cupon;

        this.cn = options.cn;

        this.user = undefined;
        this.orderList = [];

        // Скрытая форма
        this.form = document.querySelector<HTMLFormElement>(this.cn.setElem('hidden-form').toSelector()) as HTMLFormElement;
        // Поле бонусов в скрытой форме
        this.bonusesField = document.querySelector<HTMLInputElement>(this.cn.setElem('hidden-form-value-field').toSelector()) as HTMLInputElement;
        // Поле промокода в скрытой форме
        this.cuponField = document.querySelector<HTMLInputElement>(this.cn.setElem('hidden-form-promocode-field').toSelector()) as HTMLInputElement;

        // Обертка программы лояльности. Подумать о том что логику скрытия/открытия нужно поменять с учетом бонусов
        this.wrapper = document.querySelector(this.cn.setElem('wrapper').toSelector());

        this.state = {
            status: 'default',
            bonuses: { applied: 0, collected: 0, maxToApply: 0 },
            loyaltyValue: this.bonuses.fieldBonuses?.value || STATUS_DISCOUNT.DISCOUNT_DELETED,
            cupone: {
                value: '',
                error: undefined
            }
        };

        this.callbackConnection();
    }

    sendInsalesForm() {
        if (! this.form) {
            throw new Error('PANIC');
        }

        this.form.submit();
    }

    getFromFieldFromHtmlById(id: number): HTMLInputElement | undefined {
        return document.querySelector(`[name="order[fields_values_attributes][${id}][value]"]`) as HTMLInputElement | undefined;
    }

    getFormFiledValueFromHtml(id: number) {
        const field = this.getFromFieldFromHtmlById(id);

        return field?.value || '';
    }

    callbackConnection() {
        // Для отправки формы
        this.bonuses?.buttonSubmit?.addEventListener('click', () => {
            this.sendInsalesForm();
        });
        // Для отправки формы
        this.cupon?.couponSubmitButton?.addEventListener('click', () => {
            this.sendInsalesForm();
        });

        // Сброс кол-во введенных бонусов
        this.bonuses?.buttonReset?.addEventListener('click', () => {
            this.resetBonuses();
        });
        // Сброс введенного промокода
        this.cupon?.couponResetButton?.addEventListener('click', () => {
            this.resetCupon();
        });

        this.bonuses?.variantButtonBonusesEarn?.addEventListener('change', () => {
            if (this.bonuses?.variantButtonBonusesEarn?.checked) {
                this.resetBonuses();
            }
        });

        // Для понимания можем ли мы использова ПЛ
        EventBus.subscribe('update_items:insales:cart', async CartState => {
            if (! CartState.order_lines.length) {
                return;
            }

            await this.process(CartState);

            this.defineStrategy(CartState.order_lines)
                .then(defineStrategy => {
                    if (defineStrategy === 'disabled') {
                        this.hiddenLoyalty();
                    }
                });
        });

        this.synchronizedBonusesField(this.bonuses.fieldBonuses, this.bonusesField);
        this.bonuses.fieldBonuses?.addEventListener('input', () => {
            this.synchronizedBonusesField(this.bonuses.fieldBonuses, this.bonusesField);
        });

        this.synchronizedCuponeField(this.cupon?.fieldCupon, this.cuponField);
        this.cupon?.fieldCupon?.addEventListener('input', () => {
            this.synchronizedCuponeField(this.cupon?.fieldCupon, this.cuponField);
        });
    }

    resetForm() {
        const BONUSES = this.getFromFieldFromHtmlById(FILED_MAP.BONUSES);
        const CUPON = this.getFromFieldFromHtmlById(FILED_MAP.CUPON);

        if (BONUSES) {
            BONUSES.value = '';
        }

        if (CUPON) {
            CUPON.value = '';
        }

        this.sendInsalesForm();
    }

    resetBonuses() {
        const BONUSES = this.getFromFieldFromHtmlById(FILED_MAP.BONUSES);

        if (BONUSES) {
            BONUSES.value = '';
        }

        this.sendInsalesForm();
    }

    resetCupon() {
        const CUPON = this.getFromFieldFromHtmlById(FILED_MAP.CUPON);

        if (CUPON) {
            CUPON.value = '';
        }

        this.sendInsalesForm();
    }

    hiddenLoyalty() {
        this.wrapper?.classList.add(this.cn.setElem('wrapper').setMode({ hidden: true }).toString());
    }

    openLoyalty() {
        this.wrapper?.classList.remove(this.cn.setElem('wrapper').setMode({ hidden: true }).toString());
    }

    static getBalanceHistory(userPhone: string): Promise<HistoryResponseInt> {
        return Gate31ApiV2.getBalanceHistory(userPhone);
    }

    static getBalanceUser(userPhone: string): Promise<{
        balance: { available: number; blocked: number };
        level: string;
        customer: any;
        segments: string[];
    }> {
        return Gate31ApiV2.loyaltyGetUser(userPhone)
            .then(response => {
                const segment = response?.customerSegmentations?.find(item => item?.segmentation?.name === 'Участники ПЛ');
                const balance = response?.balances?.find(item => item.systemName === 'mainBalance');

                return {
                    balance: {
                        available: balance?.available || 0,
                        blocked: balance?.blocked || 0
                    },
                    level: segment?.segment?.name || '',
                    customer: response.customer || {},
                    segments: response?.customerSegmentations.filter(item => item.segment)?.map(item => item.segmentation?.name || '').filter(Boolean) || []
                };
            });
    }

    async getUserData(): Promise<ClientResponseInt | undefined> {
        if (this.user) {
            return this.user;
        }

        this.user = await Client.get()
            .then(res => res.status === 'ok' ? res : undefined)
            .catch(() => undefined);

        return this.user;
    }

    getBodyForCalculateAccrual(): bodyForCalculateAccrualInt | undefined {
        // if (! this.user?.client?.phone) {
        //     return;
        // }

        return {
            fields_values: [
                {
                    field_id: FILED_MAP.BONUSES,
                    value: this.getFormFiledValueFromHtml(FILED_MAP.BONUSES),
                    handle: FILED_HANDLE_MAP.BONUSES
                },
                {
                    field_id: FILED_MAP.SAMPLI_SALE,
                    value: this.getFormFiledValueFromHtml(FILED_MAP.SAMPLI_SALE),
                    handle: FILED_HANDLE_MAP.SAMPLI_SALE
                },
                {
                    field_id: FILED_MAP.SALE,
                    value: this.getFormFiledValueFromHtml(FILED_MAP.SALE),
                    handle: FILED_HANDLE_MAP.SALE
                },
                {
                    field_id: FILED_MAP.CUPON,
                    value: this.getFormFiledValueFromHtml(FILED_MAP.CUPON),
                    handle: FILED_HANDLE_MAP.CUPON
                }
            ],
            client: this.user?.client,
            order_lines: this.orderList
            // total_profit: this.order.total_profit
        };
    }

    /**
     * Метод перезаписывает ТЕХНИЧЕСКОЕ НАЗВАНИЕ СКИДКИ на нормально (для стр оформления заказа) (для стра заказа)
     */
    static updateDiscountName() {
        const dataOrderNode = document.querySelector('[data-order]') as HTMLElement;
        const dataOrderString = dataOrderNode?.getAttribute('data-order') as string;
        const dataOrder = JSON.parse(dataOrderString || '{}');
        const discount = dataOrder?.discounts?.[0];

        // const discountDescription: string = discount?.description || '';

        let htmlDiscount = LiquidRender.render('order-discount', { discount: { description: discount?.description || '', amount: discount?.amount || 0 } });

        const discountContainer = document.querySelector('[id="discounts-block"');

        if (discountContainer) {
            discountContainer.innerHTML = htmlDiscount;
        }

        // const discountDataArr = discountDescription.split(' ');
        // const bonuses = discountDataArr.find(item => item.includes('BONUSES='))?.replace('BONUSES=', '');
        // const bonusesValue = discountDataArr.find(item => item.includes('BONUSES_DISCOUNT='))?.replace('BONUSES_DISCOUNT=', '');
        // const cupon = discountDataArr.find(item => item.includes('COUPONE='))?.replace('COUPONE=', '');
        // const cuponValue = discountDataArr.find(item => item.includes('COUPONE_DISCOUNT='))?.replace('COUPONE_DISCOUNT=', '');

        // const discountSaleHTML = document.querySelector('[data-discount-sale]');
        // let discountSale = '';

        // if (discountSaleHTML) {
        //     discountSale = discountSaleHTML.getAttribute('data-discount-sale') as string;
        // }

        // const nameHTMLListInOrder = document.querySelectorAll('.account-order-list__result-name');

        // nameHTMLListInOrder.forEach(item => {
        //     if (item.innerHTML.indexOf(TECHNICAL_STRING) >= 0) {
        //         const objectTitle = TITLE_LIST.find(nameObj => nameObj.name === discountSale) || TITLE_LIST.find(nameObj => nameObj.name === 'default');

        //         if (objectTitle) {
        //             item.innerHTML = objectTitle.title;
        //         }
        //     }
        // });

        $(document).on('loaded:insales:payments', () => {
            htmlDiscount = LiquidRender.render('order-discount', { discount: { description: discount?.description || '', amount: discount?.amount || 0 } });
            if (discountContainer) {
                discountContainer.innerHTML = htmlDiscount;
            }
        });
    }

    setOrderList(list: Array<VarProduct> | []): Array<VarProduct> | [] {
        return this.orderList = list;
    }

    async process(CartState: {
        // eslint-disable-next-line
        order_lines: Array<VarProduct>;
        discounts: Array<{
            discount: number | string;
            amount: number;
            description: string;
        }>;
    }) {
        this.setOrderList(CartState.order_lines);

        this.user = await this.getUserData();

        const bodyForCalculateAccrual = this.getBodyForCalculateAccrual();

        if (! bodyForCalculateAccrual) {
            return;
        }

        await Gate31ApiV2.calculatePurchase(bodyForCalculateAccrual)
            .then(response => {
                // Результаты вычисления баланс
                const balance = response.order?.bonusPointsChanges?.find((item: any) => item?.balanceType?.ids?.systemName === 'mainBalance');
                const preBalance = response.order?.bonusPointsInfoPerBalanceType?.find((item: any) => item?.balanceType?.ids?.systemName === 'mainBalance');

                const cupon = response.order?.couponsInfo?.[0];

                // Максимально доступная сумма к списанию для текуущего заказа
                this.state.bonuses.maxToApply = preBalance?.availableAmountForCurrentOrder || 0;
                // Будет начислено
                this.state.bonuses.collected = balance?.earnedAmount || 0;
                // Будет списано
                this.state.bonuses.applied = balance?.spent || 0;

                // Переданный промокод
                this.state.cupone.value = cupon?.coupon?.ids?.code || '';

                if (cupon?.coupon?.status === 'NotFound') {
                    this.state.cupone.error = 'Промокод не найден';
                }
            })
            .then(() => {
                this.bonuses.renderCollected(this.state.bonuses.collected);
                this.bonuses.renderBalance(this.state.bonuses.maxToApply);
                this.bonuses.addLimitation(this.state.bonuses.maxToApply);

                if (! this.user) {
                    // Показываем заглушку для не авторизованный пользователей
                    this.openLoyalty();
                }

                if (this.user) {
                    if (this.state.bonuses.maxToApply || this.state.bonuses.collected) {
                        this.openLoyalty();
                    } else {
                        this.hiddenLoyalty();
                    }
                }

                this.cupon?.renderError(this.state.cupone.error);
            })
            .catch(error => {
                faro.api.pushError(error, {
                    context: {
                        section: 'Loyalty-Mindbox',
                        component: 'get-client'
                    }
                });

                throw error;
            });
    }

    /**
     * Определяем поведение программы лояльности на основе клиента и корзины
     * @param orderLines
     */
    async defineStrategy(orderLines: Array<VarProduct>): Promise<'disabled' | 'enabled' | 'partially'> {
        const clientGroupId = await Client.getGroupId();
        const clientGroup = clientGroupId ? CLIENT_GROUP_LIST.find(item => item.id === clientGroupId)?.title : undefined;

        const characteristicsList = orderLines
            .map(orderItem => orderItem.product.characteristics)
            .flat();

        const productSimpleSaleListLength = characteristicsList.filter(item => item.permalink === FILED_HANDLE_MAP.SAMPLI_SALE && item.property_id === ACTION_PROP_ID)?.length;
        const productSaleListLength = characteristicsList.filter(item => item.permalink === FILED_HANDLE_MAP.SALE && item.property_id === ACTION_PROP_ID)?.length;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const isSampleSale = Boolean(productSimpleSaleListLength);
        const isSale = Boolean(productSaleListLength);

        if (orderLines.length === productSimpleSaleListLength) {
            // У всех товаров sample-sale
            return 'disabled';
        }

        if (clientGroup === 'HOME31') {
            if (isSale) {
                return 'partially';
            }

            return 'disabled';
        }

        if (clientGroup === 'Сотрудники') {
            return 'disabled';
        }

        return 'enabled';
    }

    synchronizedBonusesField(input: HTMLInputElement | null, output: HTMLInputElement | null) {
        if (! input || ! output) {
            return;
        }

        output.value = input.value;

        if (input.value === '0' || input.value === '') {
            output.value = STATUS_DISCOUNT.DISCOUNT_DELETED;

            return;
        }
    }

    synchronizedCuponeField(input: HTMLInputElement | null, output: HTMLInputElement | null) {
        if (! output || ! input) {
            return;
        }

        output.value = input.value;
    }
}
